import { render, staticRenderFns } from "./HintsContainer.vue?vue&type=template&id=0ea25da7&scoped=true"
import script from "./HintsContainer.vue?vue&type=script&lang=ts"
export * from "./HintsContainer.vue?vue&type=script&lang=ts"
import style0 from "./HintsContainer.vue?vue&type=style&index=0&id=0ea25da7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea25da7",
  null
  
)

export default component.exports